var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tension-root tension",class:_vm.enabled,on:{"click":function($event){return _vm.doClick()}}},[_c('span',{staticClass:"tension-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }